import * as React from "react";
import * as TogglePrimitives from "@radix-ui/react-switch";
import { cx } from "class-variance-authority";

import { Skeleton } from "../Skeleton/Skeleton";
import * as styles from "./Toggle.module.scss";

type ToggleProps = {
  label?: string;
  noSpacing?: boolean;
  loading?: boolean;
  labelRight?: boolean;
  labelClass?: string;
  trackClass?: string;
} & TogglePrimitives.SwitchProps;

const Toggle = React.forwardRef<HTMLButtonElement, ToggleProps>(
  (
    {
      className,
      label,
      labelClass,
      trackClass,
      noSpacing,
      id,
      loading = false,
      labelRight = false,
      ...props
    },
    ref,
  ) => {
    const uniqueId = React.useId();
    return (
      <div
        className={cx(className, styles.container, {
          [styles.noSpacing]: noSpacing,
          [styles.reverse]: labelRight,
        })}
      >
        {labelRight && label && (
          <label
            htmlFor={id ?? uniqueId}
            className={cx(styles.label, labelClass)}
          >
            {label}
          </label>
        )}
        {loading ? (
          <Skeleton className={cx(className, styles.skeleton)} />
        ) : (
          <TogglePrimitives.Root
            id={id ?? uniqueId}
            className={cx(styles.track, trackClass)}
            {...props}
            ref={ref}
          >
            <TogglePrimitives.Thumb className={styles.thumb} />
          </TogglePrimitives.Root>
        )}
        {label && !labelRight && (
          <label
            htmlFor={id ?? uniqueId}
            className={cx(styles.label, labelClass)}
          >
            {label}
          </label>
        )}
      </div>
    );
  },
);
Toggle.displayName = "Toggle";

export { Toggle };
